import React, { useEffect, useState } from 'react';
import { useHistory } from "react-router-dom";

import {
    IonContent,
    IonHeader,
    IonPage,
    IonTitle,
    IonToolbar,
    IonButton,
    IonRow,
    IonCol,
    IonIcon,
    IonLabel
} from '@ionic/react';
import ExploreContainer from '../components/ExploreContainer';
import './Impianto.css';


import { flashlight } from 'ionicons/icons';

import { power } from 'ionicons/icons';


const Impianto: React.FC = () => {

    const [btnClassPower_1, setBtnClassPower_1] = useState(false);
    const [btnColorPower_1, setBtnColorPower_1] = useState("white");

    const [btnClassPower_2, setBtnClassPower_2] = useState(false);
    const [btnColorPower_2, setBtnColorPower_2] = useState("white");

    const [btnClassPower_3, setBtnClassPower_3] = useState(false);
    const [btnColorPower_3, setBtnColorPower_3] = useState("white");

    const [btnClassPower_4, setBtnClassPower_4] = useState(false);
    const [btnColorPower_4, setBtnColorPower_4] = useState("white");

 



    const [btnClassFlash_1, setbtnFlashClass_1] = useState(false);
    const [btnFlashColor_1, setbtnColorFlash_1] = useState("white");

    const [btnClassFlash_2, setbtnFlashClass_2] = useState(false);
    const [btnFlashColor_2, setbtnColorFlash_2] = useState("white");

    const [btnClassFlash_3, setbtnFlashClass_3] = useState(false);
    const [btnFlashColor_3, setbtnColorFlash_3] = useState("white");

    const [btnClassFlash_4, setbtnFlashClass_4] = useState(false);
    const [btnFlashColor_4, setbtnColorFlash_4] = useState("white");

    var history = useHistory();
    return (
        <IonPage  >

            <ExploreContainer name="Home page" />
            <IonHeader style={{ height: "6%"}}>
                <IonToolbar style={{ height: "100%", paddingTop: "10px" }} class={'toolback'}>
                    <IonTitle class={'background-content'} style={{ fontSize: "30px"}}>Forno Cucina</IonTitle>
                </IonToolbar>
            </IonHeader>


            <IonContent class={'background-content'} fullscreen >


                <IonRow style={{ paddingTop: "50px", height: "45%" }}>
                    <IonCol class={"borderColumn"} style={{ backgroundColor: "white", marginLeft: "8%" }} size="5">

                        <IonRow style={{ height: "41%" }} >
                            <IonRow style={{ height: "25%", width: "100%", backgroundColor: "#a2282a", textAlign: "center" }} >
                                <IonLabel style={{ color: "white", fontSize: "25px", paddingLeft: "25%", paddingTop: "5px", paddingBottom: "10px", textAlign: "center" }}>Forno 1 - Pinsa </IonLabel>
                            </IonRow>
                            <div style={{ fontSize: "30px", paddingTop: "5%", paddingLeft: "5%" }}>% Cielo:  70</div>
                            <div style={{ fontSize: "30px", paddingTop: "5%", paddingLeft: "5%" }}>% Platea:  30</div>
                            <div style={{ fontSize: "30px", paddingTop: "5%", paddingLeft: "5%" }}>SetPoint:  350°</div>
                        </IonRow>

                        <IonRow class={'borderRowButt'} style={{ backgroundColor: "white", height: "22%", marginTop: "47%" }} >

                            <IonCol class={'borderButton'} style={{backgroundColor: btnColorPower_1}}size="4">
                                <IonButton onClick={() => {
                                    btnClassPower_1 ? setBtnClassPower_1(false) : setBtnClassPower_1(true);
                                    btnColorPower_1 === "white" ? setBtnColorPower_1("#25D366") : setBtnColorPower_1("white");
                                }}
                                    className={btnClassPower_1 ? "btnClass clicked" : "btnClass"} fill="clear" style={{ height: "auto" }}>
                                    <IonIcon icon={power} style={{ backgroundColor: btnClassPower_2, color: "gray", fontSize: "50px", marginTop: "8px" }}></IonIcon>
                                </IonButton>
                            </IonCol>

                            <IonCol class={'borderButton'} style={{backgroundColor: btnFlashColor_1}} size="4">

                                <IonButton onClick={() => {
                                    btnClassFlash_1 ? setbtnFlashClass_1(false) : setbtnFlashClass_1(true);
                                    btnFlashColor_1 === "white" ? setbtnColorFlash_1("#ffff00") : setbtnColorFlash_1("white");
                                }}
                                    className={btnClassFlash_1 ? "btnClass clicked" : "btnClass"} fill="clear" style={{ height: "auto" }}>
                                    <IonIcon icon={flashlight} style={{backgroundColor: btnFlashColor_1, color: "gray", fontSize: "50px", marginTop: "7px" }}></IonIcon>
                                </IonButton>
                            </IonCol>

                            <IonCol size="4">
                                <div style={{ fontSize: "30px", textAlign: "center", paddingTop: "18%" }}>350°</div>
                            </IonCol>

                        </IonRow>

                    </IonCol>

                    <IonCol class={"borderColumn"} style={{ backgroundColor: "white", marginLeft: "1%" }} size="5">
                        <IonRow style={{ height: "10%", width: "100%", backgroundColor: "#a2282a", textAlign: "center" }} >
                            <IonLabel style={{ color: "white", fontSize: "25px", paddingLeft: "2%", paddingTop: "5px", paddingBottom: "10px", textAlign: "center" }}>Forno 2 -teglia</IonLabel>
                        </IonRow>
                        <IonRow style={{ height: "31%" }} >
                            <div style={{ fontSize: "30px", paddingTop: "5%", paddingLeft: "5%" }}>% Cielo:  70</div>
                            <div style={{ fontSize: "30px", paddingTop: "5%", paddingLeft: "5%" }}>% Platea:  30</div>
                            <div style={{ fontSize: "30px", paddingTop: "5%", paddingLeft: "5%" }}>SetPoint:  350°</div>
                        </IonRow>

                        <IonRow class={'borderRowButt'} style={{ backgroundColor: "white", height: "22%", marginTop: "47%" }} >

                            <IonCol class={'borderButton'}  style={{backgroundColor: btnColorPower_2}} size="4">
                                <IonButton onClick={() => {
                                    btnClassPower_2 ? setBtnClassPower_2(false) : setBtnClassPower_2(true);
                                    btnColorPower_2 === "white" ? setBtnColorPower_2("#25D366") : setBtnColorPower_2("white");
                                }}
                                    className={btnClassPower_2 ? "btnClass clicked" : "btnClass"} fill="clear" style={{ height: "auto" }}>
                                    <IonIcon icon={power} style={{backgroundColor: btnClassPower_2,color: "gray", fontSize: "50px", marginTop: "8px" }}></IonIcon>
                                </IonButton>
                            </IonCol>

                            <IonCol class={'borderButton'} style={{backgroundColor: btnFlashColor_2}} size="4">

                                <IonButton onClick={() => {
                                    btnClassFlash_2 ? setbtnFlashClass_2(false) : setbtnFlashClass_2(true);
                                    btnFlashColor_2 === "white" ? setbtnColorFlash_2("#ffff00") : setbtnColorFlash_2("white");
                                }} fill="clear" style={{ height: "auto" }}>
                                    <IonIcon icon={flashlight} style={{ backgroundColor: btnFlashColor_2 , color: "gray", fontSize: "50px", marginTop: "7px" }}></IonIcon>
                                </IonButton>
                            </IonCol>

                            <IonCol size="4">
                                <div style={{ fontSize: "30px", textAlign: "center", paddingTop: "18%" }}>350°</div>
                            </IonCol>

                        </IonRow>

                    </IonCol>

                </IonRow>


                <IonRow style={{ marginTop: "5%", height: "45%" }}>
                    <IonCol class={"borderColumn"} style={{ backgroundColor: "white", marginLeft: "8%" }} size="5">
                        <IonRow style={{ height: "10%", width: "100%", backgroundColor: "#a2282a", textAlign: "center" }} >
                            <IonLabel style={{ color: "white", fontSize: "25px", paddingLeft: "20%", paddingTop: "5px", paddingBottom: "10px", textAlign: "center" }}>Forno 3 - Prerisc.</IonLabel>
                        </IonRow>
                        <IonRow style={{ height: "30%" }} >
                            <div style={{ fontSize: "30px", paddingTop: "5%", paddingLeft: "5%" }}>% Cielo:  70</div>
                            <div style={{ fontSize: "30px", paddingTop: "5%", paddingLeft: "5%" }}>% Platea:  30 </div>
                            <div style={{ fontSize: "30px", paddingTop: "5%", paddingLeft: "5%" }}>SetPoint:  350°</div>
                        </IonRow>

                        <IonRow class={'borderRowButt'} style={{ backgroundColor: "white", height: "20%", marginTop: "55%" }} >

                            <IonCol class={'borderButton'} style={{backgroundColor:btnColorPower_3}} size="4">
                                <IonButton onClick={() => {
                                    btnClassPower_3 ? setBtnClassPower_3(false) : setBtnClassPower_3(true);
                                    btnColorPower_3 === "white" ? setBtnColorPower_3("#25D366") : setBtnColorPower_3("white");
                                }}
                                    className={btnClassPower_1 ? "btnClass clicked" : "btnClass"} fill="clear" style={{ height: "auto" }}>
                                    <IonIcon icon={power} style={{ backgroundColor:btnColorPower_3,color: "gray", fontSize: "50px", marginTop: "8px" }}></IonIcon>
                                </IonButton>
                            </IonCol>

                            <IonCol class={'borderButton'} style={{backgroundColor:btnFlashColor_3}} size="4">

                                <IonButton onClick={() => {
                                    btnClassFlash_3 ? setbtnFlashClass_3(false) : setbtnFlashClass_3(true);
                                    btnFlashColor_3 === "white" ? setbtnColorFlash_3("#ffff00") : setbtnColorFlash_3("white");
                                }}  fill="clear" style={{ height: "auto" }}>
                                    <IonIcon icon={flashlight} style={{ backgroundColor:btnFlashColor_3, color: "gray", fontSize: "50px", marginTop: "7px" }}></IonIcon>
                                </IonButton>
                            </IonCol>

                            <IonCol size="4">
                                <div style={{ fontSize: "30px", textAlign: "center", paddingTop: "18%" }}>350°</div>
                            </IonCol>

                        </IonRow>

                    </IonCol>

                    <IonCol class={"borderColumn"} style={{ backgroundColor: "white", marginLeft: "1%" }} size="5">
                        <IonRow style={{ height: "10%", width: "100%", backgroundColor: "#a2282a", textAlign: "center" }} >
                            <IonLabel style={{ color: "white", fontSize: "25px", paddingLeft: "10%", paddingTop: "5px", paddingBottom: "10px", textAlign: "center" }}>Forno 4 - Pizza al matt.</IonLabel>
                        </IonRow>
                        <IonRow style={{ height: "30%" }} >
                            <div style={{ fontSize: "30px", paddingTop: "5%", paddingLeft: "5%" }}>% Cielo:  70</div>
                            <div style={{ fontSize: "30px", paddingTop: "5%", paddingLeft: "5%" }}>% Platea:  30</div>
                            <div style={{ fontSize: "30px", paddingTop: "5%", paddingLeft: "5%" }}>SetPoint:  350°</div>
                        </IonRow>

                        <IonRow class={'borderRowButt'} style={{ backgroundColor: "white", height: "20%", marginTop: "55%" }} >

                            <IonCol class={'borderButton'} style={{backgroundColor:btnColorPower_4}}size="4">
                                <IonButton onClick={() => {
                                    btnClassPower_4 ? setBtnClassPower_4(false) : setBtnClassPower_4(true);
                                    btnColorPower_4 === "white" ? setBtnColorPower_4("#25D366") : setBtnColorPower_4("white");
                                }}
                                    className={btnClassPower_1 ? "btnClass clicked" : "btnClass"}  fill="clear" style={{ height: "auto" }}>
                                    <IonIcon icon={power} style={{backgroundColor:btnColorPower_4, color: "gray", fontSize: "50px", marginTop: "8px" }}></IonIcon>
                                </IonButton>
                            </IonCol>

                            <IonCol class={'borderButton'} style={{backgroundColor: btnFlashColor_4}} size="4">

                                <IonButton onClick={() => {
                                    btnClassFlash_4 ? setbtnFlashClass_4(false) : setbtnFlashClass_4(true);
                                    btnFlashColor_4 === "white" ? setbtnColorFlash_4("#ffff00") : setbtnColorFlash_4("white");
                                }} fill="clear" style={{ height: "auto" }}>
                                    <IonIcon icon={flashlight} style={{backgroundColor: btnFlashColor_4, color: "gray", fontSize: "50px", marginTop: "7px" }}></IonIcon>
                                </IonButton>
                            </IonCol>

                            <IonCol size="4">
                                <div style={{ fontSize: "30px", textAlign: "center", paddingTop: "18%" }}>350°</div>
                            </IonCol>

                        </IonRow>

                    </IonCol>

                </IonRow>
























            </IonContent>
        </IonPage>
    );
};

export default Impianto;
